import React, {useMemo} from 'react';
import {Table, Tabs} from "antd";
import ColorTag from "../../../components/ColorTag";
import {useProject} from "../../../providers/ClientProjectProvider";
import TeamCandidateScopeProvider, {useTeamCandidateScope} from "../team-scope/TeamCandidateScopeProvider";
import AssignedTeamSummaryTable from "../../project-bidding/components/AssignedTeamSummaryTable";
import TeamCandidateProvider from "../../../providers/TeamCandidateProvider";
import ProjectDisciplinesTable from "./ProjectDisciplinesTable";
import ProjectScopeProvider from "./ProjectScopeProvider";
import LoadingSpinner from "../../../components/LoadingSpinner";


const DeliverableTable = ({scope, forTeam}) => {
    const {project, isDisabled} = useProject();

    const lookupType = forTeam ? 'team_' : '';
    const deliverableData = useMemo(() => {
        let activeDeliverables = TB.filter(
            TB.flatMap(
                [...(scope?.phases || [])],
                'deliverables'
            ), ['is_active', true]
        )

        return TB.map(activeDeliverables, deliverable => {
            deliverable.disciplines = TB.uniqBy(TB.flatMap(deliverable.activities, 'disciplines'), 'id')

            return deliverable;
        })
    }, [isDisabled, project]);

    const hasConfirmedScope = project?.hasConfirmedProjectScope();
    return (
        <Table
            rowKey="id"
            dataSource={deliverableData}
            summary={(pageData) => {
                let totalHours = TB.sumBy(pageData,`total_${lookupType}hours`);
                let totalEstCost = TB.sumBy(pageData, `estimated_platform_cost`);

                return (
                    <Table.Summary.Row className="bg-gray-300">
                        <Table.Summary.Cell index={0}>
                            <p className="text-sm font-medium">
                                Total
                            </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={1}>

                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={2}>
                            <p className="text-sm font-medium">
                                {hasConfirmedScope ? `${totalHours} hrs` : '-'}
                            </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={3}>
                            <p className="text-sm font-medium">
                                {hasConfirmedScope ? TB.formatCurrency(totalEstCost, false) : 'TBD'}
                            </p>
                        </Table.Summary.Cell>
                    </Table.Summary.Row>
                );
            }}
            bordered
            size="small"
            pagination={false}>


            <Table.Column
                title="Deliverable"
                dataIndex="name"
                render={name => (
                    <p className="text-xs whitespace-nowrap">
                        {name}
                    </p>
                )}
            />
            <Table.Column
                title="Roles"
                dataIndex="disciplines"
                key="disciplines"
                render={disciplines => (
                    <div className="flex flex-row items-start flex-wrap justify-start gap-y-2.5 gap-x-2">
                        {disciplines.map((discipline) => (
                            <ColorTag key={`roles-${discipline.id}`} label={discipline.name} closable={false}/>
                        ))}
                    </div>
                )}
            />
            <Table.Column
                title="Hours"
                dataIndex={`total_${lookupType}hours`}
                width={100}
                render={total_hours => (
                    <p className={"text-xs whitespace-nowrap"}>
                        {hasConfirmedScope ? (total_hours || 0) : '-'}
                    </p>
                )}
            />

            <Table.Column
                title="Est. Cost"
                dataIndex={`estimated_platform_cost`}
                width={120}
                render={estimated_cost => (
                    <p className="text-xs whitespace-nowrap">
                        {hasConfirmedScope ? TB.formatCurrency(estimated_cost, false) : 'TBD'}
                    </p>
                )}
            />

        </Table>
    )
}


const TeamDeliverableTable = () => {
    const {team, isLoading} = useTeamCandidateScope();
    if (isLoading || !team) {
        return (
            <div className="flex flex-col items-center py-5">
                <LoadingSpinner size="lg"/>
            </div>
        )
    }
    return (
        <DeliverableTable forTeam={true} scope={team}/>
    )
}
const Wrapper = (props) => {
    const {project, isDisabled} = useProject();

    if (project.hasAssignedCandidates()) {
        return (
            <TeamCandidateProvider team={project.assigned_team_candidate}>
                <TeamCandidateScopeProvider forAssigned={true} project={project}>
                    {props.children}
                </TeamCandidateScopeProvider>
            </TeamCandidateProvider>
        )
    }
    return (
        <ProjectScopeProvider>
            {props.children}
        </ProjectScopeProvider>
    )
}
const ProjectDeliverablesTable = ({canManage, size = "middle", className = "", ...props}) => {
    const {project, isDisabled} = useProject();

    if (!project) {
        return null;
    }

    return (
        <div className={className + " flex flex-col gap-6 items-stretch"}>

            <Wrapper>
                <Tabs
                    defaultActiveKey="1"
                    centered
                    items={[{
                            label: `Est. Cost By Role`,
                            key: '1',
                            children: (
                                project.hasAssignedCandidates() ? (
                                    <div className="min-h-[350px]">
                                        <AssignedTeamSummaryTable canManage={canManage}/>
                                    </div>
                                ) : <ProjectDisciplinesTable/>
                            ),
                        },
                        {
                            label: `Est. Cost By Deliverable`,
                            key: '2',
                            children: (
                                project.hasAssignedCandidates() ? (
                                    <div className="min-h-[350px]">
                                        <TeamDeliverableTable/>
                                    </div>
                                ) : <DeliverableTable scope={project}/>
                            ),
                        }
                    ]}
                />
            </Wrapper>
        </div>
    );
};

export default ProjectDeliverablesTable;